import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./Reveal";

const FAQS = [
  {
    q: "Do I need prior braiding experience?",
    a: "Level 1 is designed to take you from foundations to professional. Beginners are welcome, and experienced braiders will refine and elevate their technique.",
  },
  {
    q: "When and where does the program run?",
    a: "The first Crowned™ Pro cohort launches September 15, 2026. It runs for 6 weeks with live, hands-on sessions at the Beauti N Braid Academy studio. Exact schedule is shared upon enrollment.",
  },
  {
    q: "What's included in the tuition?",
    a: "Everything you need: live instruction, your complete starter tool & product kit, certification, portfolio photo day, the business playbook, and lifetime alumni community access.",
  },
  {
    q: "Are payment plans available?",
    a: "Yes. You can pay in full at the early-crown rate or split into 3 monthly payments. Reserve your seat and our team will walk you through the options.",
  },
  {
    q: "Will I be certified after completing Level 1?",
    a: "Absolutely. Graduates receive the official Crowned™ Pro Level 1 certification, recognized across our partner network.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="bg-wine-deep py-24 sm:py-32">
    <div className="max-w-[900px] mx-auto px-6">
      <Reveal className="text-center mb-14">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">
          Questions
        </span>
        <h2 className="font-display font-light text-cream text-5xl sm:text-6xl leading-[1] mt-5">
          Everything you need to know.
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-${i}`}
              className="border-b border-gold/15"
            >
              <AccordionTrigger className="text-left font-display text-2xl text-cream hover:text-gold hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-cream/60 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
